import { makeStyles } from 'tss-react/mui';

import type { LeaveType, TeamMember } from '../data/model';
import { LEAVE_TYPES } from '../data/model';
import { fonts, themeTokens } from '../theme';

const useStyles = makeStyles()(theme => {
  const palette = themeTokens(theme);
  return {
    avatar: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      color: '#FBFAF7',
      fontFamily: fonts.mono,
      fontWeight: 600,
      letterSpacing: '0.02em',
      flexShrink: 0,
    },
    typeBadge: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '2px 10px',
      borderRadius: 999,
      fontFamily: fonts.mono,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      lineHeight: 1.6,
      whiteSpace: 'nowrap',
    },
    dot: { width: 8, height: 8, borderRadius: '50%', flexShrink: 0 },
    legend: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 16,
      alignItems: 'center',
    },
    legendItem: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      fontFamily: fonts.mono,
      fontSize: 12,
      letterSpacing: '0.03em',
      color: palette.muted,
    },
  };
});

export const MemberAvatar = ({
  member,
  size = 36,
}: {
  member: TeamMember;
  size?: number;
}) => {
  const { classes } = useStyles();
  return (
    <span
      className={classes.avatar}
      style={{
        width: size,
        height: size,
        backgroundColor: member.color,
        fontSize: Math.round(size * 0.36),
      }}
      title={member.name}
      aria-label={member.name}
    >
      {member.initials}
    </span>
  );
};

export const TypeBadge = ({ type }: { type: LeaveType }) => {
  const { classes } = useStyles();
  return (
    <span
      className={classes.typeBadge}
      style={{
        color: type.color,
        backgroundColor: `${type.color}1A`,
        border: `1px solid ${type.color}40`,
      }}
    >
      <span className={classes.dot} style={{ backgroundColor: type.color }} />
      {type.label}
    </span>
  );
};

export const LeaveTypeLegend = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.legend}>
      {LEAVE_TYPES.map(type => (
        <span key={type.id} className={classes.legendItem}>
          <span
            className={classes.dot}
            style={{ backgroundColor: type.color }}
          />
          {type.label}
        </span>
      ))}
    </div>
  );
};
